import { DATE_FULL_FORMAT } from '../../../../constants/date'
import { TableDateCell, TableStatusCell, TableTextCell } from '../../../Table'
import {
  INTEGRATION_COLUMN_NAME,
  INTEGRATION_CONNECTION_STATUSES,
} from '../RentalPortalIntegrations.constants'
import { getIntegrationConnectionStatus } from '../RentalPortalIntegrations.utils'

import { IntegrationsBrandCell } from './IntegrationsBrandCell'

export function getIsIntegrationsRowActive({ activeItem, focusedRow, item }) {
  return focusedRow === item.portal || activeItem === item.portal
}

export function renderIntegrationsCell({ item, name, t, ...restProps }) {
  switch (name) {
    case INTEGRATION_COLUMN_NAME.Integration:
      return <IntegrationsBrandCell {...restProps} connection={item} />

    case INTEGRATION_COLUMN_NAME.Status:
      return (
        <TableStatusCell
          {...restProps}
          statuses={INTEGRATION_CONNECTION_STATUSES}
          value={getIntegrationConnectionStatus(item)}
        />
      )

    case INTEGRATION_COLUMN_NAME.Type:
      return (
        <TableTextCell
          {...restProps}
          value={t('RentalPortal.IntegrationsTypePortalKey')}
        />
      )

    case INTEGRATION_COLUMN_NAME.LastChecked:
      return (
        <TableDateCell
          {...restProps}
          dateFormat={DATE_FULL_FORMAT}
          value={item.last_checked_at}
        />
      )

    default:
      return null
  }
}
